import React, { Component } from "react";
import { Form } from "antd";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazy-load";

import { GlobalContext } from "../../../../app/providers/GlobalState";

import MsgSecundaria from "../../../../Geral/_Aux/MsgSecundaria";

import { celebrate } from "../../../../assets/mensagens";

class RegistoConclusao extends Component {
    static contextType = GlobalContext;
    render() {
        const url = this.props.match.params.entidade;

        return (
            <>
                <div className="pagina-erro">
                    <div className="hero" style={{ height: 620 }}>
                        <div className="container" style={{ marginTop: 60 }}>
                            <div className="pagina-erro-header">
                                <div className="container-img">
                                    <img src={celebrate} alt="Celebrate" />
                                </div>
                            </div>
                            <div className="pagina-erro-content">
                                <MsgSecundaria texto="Parabéns por ter criado conta na STEPFORMA" style={{ fontSize: 32 }} />
                                <MsgSecundaria texto="Boa aprendizagem!" />
                                <Link
                                    to={`/${url}/login`}
                                    className="botao-principal"
                                    onClick={() => localStorage.removeItem("codigo_utilizador")}
                                >
                                    Ir para STEPFORMA
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
const FormRegistoConclusao = Form.create({ name: "registo-conclusao" })(RegistoConclusao);

export default FormRegistoConclusao;
